var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.372 5.07104L12.372 1.07104C12.2202 1.0102 12.0558 0.98752 11.8932 1.00499C11.7306 1.02246 11.5747 1.07954 11.4393 1.17123C11.3039 1.26292 11.193 1.38643 11.1165 1.53092C11.0399 1.67542 10.9999 1.8365 11 2.00004V6.00004H2C1.73478 6.00004 1.48043 6.10539 1.29289 6.29293C1.10536 6.48047 1 6.73482 1 7.00004V22C1 22.2653 1.10536 22.5196 1.29289 22.7071C1.48043 22.8947 1.73478 23 2 23H22C22.2652 23 22.5196 22.8947 22.7071 22.7071C22.8946 22.5196 23 22.2653 23 22V6.00004C23.0002 5.80016 22.9404 5.60482 22.8285 5.43923C22.7165 5.27364 22.5575 5.14539 22.372 5.07104V5.07104ZM3 8.00004H11V21H3V8.00004ZM13 21V3.47704L21 6.67704V8.00004H15V10H21V12H15V14H21V16H15V18H21V21H13ZM7 12H10V14H7V12ZM4 12H6V14H4V12ZM7 9.00004H10V11H7V9.00004ZM4 9.00004H6V11H4V9.00004ZM7 15H10V17H7V15ZM4 15H6V17H4V15ZM7 18H10V20H7V18ZM4 18H6V20H4V18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.e9bcecfa48cfe928f62a18ffc5f03733.svg";
export { ForwardRef as ReactComponent };